import { isValidWhatsAppPhone } from '@/utils/sessionWhatsAppDisplay';

export const isPatientWhatsAppNotificationsActive = (
	patient: Pick<Patients.Patient, 'whatsapp_notifications_enabled' | 'phone'>,
): boolean =>
	patient.whatsapp_notifications_enabled !== false &&
	isValidWhatsAppPhone(patient.phone);

export const PATIENT_WHATSAPP_SECTION_ID =
	'patient-whatsapp-notifications-section';
export const PATIENT_PHONE_INPUT_ID = 'patient-phone-input';
